import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { TechintelDto, TechnologyMappingResponseDto } from '../../dto';

@Injectable({
    providedIn: 'root'
})
export class TechintelApiService {
    constructor(private readonly baseApiService: BaseApiService) { }

    getExportTechIntelSavedSettingsHttp(): Observable<TechintelDto> {
        return this.baseApiService.get('service/contactcloud/techIntel/export/settings');
    }

    setExportTechIntelSavedSettings(payload): Observable<any> {
        return this.baseApiService.post('service/contactcloud/techIntel/export/settings', payload);
    }

    getTechIntelSavedSettings(): Observable<TechnologyMappingResponseDto> {
        return this.baseApiService.get('service/contactcloud/techIntel/settings');
    }

    getTechIntelSavedSettingsHttp(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/techIntel/settings', { showError: true });
    }

    setTechIntelSavedSettings(payload): Observable<any> {
        return this.baseApiService.post('service/contactcloud/techIntel/settings', payload);
    }
}
